import { animateCursorClick, animateCursorMove } from 'modules/ai_voice/lib/cursor'
import {
  dispatchClick,
  dispatchSelect,
  dispatchType,
  scrollIntoView,
} from 'modules/ai_voice/lib/dom'
import { type FindElementOptions, findElement } from 'modules/ai_voice/lib/find-element'

export async function click({ options }: { options: FindElementOptions }): Promise<void> {
  const element = await findElement(options)
  await scrollIntoView(element)
  await animateCursorMove(element, 'center')
  dispatchClick(element)
  await animateCursorClick()
}

export async function type({
  options,
  text,
}: {
  options: FindElementOptions
  text: string
}): Promise<void> {
  // eslint-disable-next-line
  const element = (await findElement(options)) as HTMLInputElement
  await scrollIntoView(element)
  await animateCursorMove(element, 'right')
  await dispatchType(element, text)
}

export async function select({
  options,
  option,
}: {
  options: FindElementOptions
  option: string
}): Promise<void> {
  // eslint-disable-next-line
  const element = (await findElement(options)) as HTMLSelectElement
  await scrollIntoView(element)
  await animateCursorMove(element, 'center')
  await animateCursorClick()
  await dispatchSelect(element, option)
}
